import { render, staticRenderFns } from "./modify-login.vue?vue&type=template&id=51779a6c&scoped=true&"
import script from "./modify-login.vue?vue&type=script&lang=js&"
export * from "./modify-login.vue?vue&type=script&lang=js&"
import style0 from "./modify-login.vue?vue&type=style&index=0&id=51779a6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51779a6c",
  null
  
)

export default component.exports